import React from 'react'
import { PageSkeleton } from '../Section/PageSkeleton'
import { SectionHeading } from '../Section'
import { LogoInline } from '../LogoInline'
import styled from 'styled-components'
import DateTime from 'luxon/src/datetime'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box
} from '@material-ui/core'
import { COMPANY, COMPANY_ADDRESS } from '../../company'

export const PrivacyPolicy = () => {
  const lastUpdatedAt = DateTime.local(2026, 10, 8).setLocale('pl')

  return (
    <PageSkeleton>
      <SectionHeading>
        Serwis <LogoInline /> - Polityka Prywatności
      </SectionHeading>

      <Box display="flex" justifyContent="center">
        <Content>
          <p>Obowiązuje od {lastUpdatedAt.toFormat('d MMMM yyyy')} r.</p>
          <p>
            Niniejsza Polityka Prywatności (zwana dalej „Polityką”) określa
            sposób zbierania, przetwarzania i przechowywania danych osobowych
            osób korzystających z serwisów internetowych CelPal dostępnych w
            domenach celpal.net, online.celpal.net, admin.celpal.net,
            portal.celpal.net i book.celpal.net (zwanych dalej „Serwisem”).
            Administratorem danych osobowych jest {COMPANY.name}, przedsiębiorca
            prowadzący jednoosobową działalność gospodarczą wpisaną do Centralnej Ewidencji i Informacji o Działalności Gospodarczej, NIP{' '}
            {COMPANY.nipNumber}, adres siedziby: {COMPANY_ADDRESS},{' '}
            {COMPANY.country} (zwany dalej „Administratorem”). Z Administratorem
            można skontaktować się pod adresem e-mail{' '}
            <a href={`mailto:${COMPANY.dataProtectionEmail}`}>
              {COMPANY.dataProtectionEmail}
            </a>{' '}
            lub pisemnie na adres siedziby.
            <br />
            <br />
            Polityka dotyczy danych wszystkich osób korzystających z Serwisu i
            aplikacji mobilnej CelPal. To, dla których danych Administrator jest
            administratorem, a które przetwarza w imieniu organizacji
            prowadzącej strzelnicę, określa sekcja „Role w przetwarzaniu danych”
            poniżej. Zasady korzystania z aplikacji mobilnej CelPal opisuje
            odrębna{' '}
            <a href="/mobilna-polityka-prywatnosci">
              Polityka Prywatności aplikacji mobilnej
            </a>
            .
            <br />
            <br />
            Przetwarzanie danych osobowych odbywa się zgodnie z Rozporządzeniem
            Parlamentu Europejskiego i Rady (UE) 2016/679 w sprawie ochrony osób
            fizycznych w związku z przetwarzaniem danych osobowych i w sprawie
            swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE
            (zwanym dalej „RODO”), ustawą o ochronie danych osobowych oraz
            ustawą o świadczeniu usług drogą elektroniczną.
          </p>

          <Title>Role w przetwarzaniu danych</Title>
          <p>
            Dane przetwarzane w Serwisie i aplikacji mobilnej dzielą się na trzy
            warstwy, niezależnie od sposobu założenia konta. Regulamin, umowa
            licencji i umowa powierzenia przetwarzania danych osobowych odwołują
            się do tego podziału.
          </p>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Warstwa danych</TableCell>
                <TableCell>Administrator</TableCell>
                <TableCell>Rola {COMPANY.name}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  1. Dane konta i dane techniczne: login lub adres e-mail,
                  hasło, adres IP, logi, dane o korzystaniu z Serwisu, zapisy
                  akceptacji regulaminów i umów.
                </TableCell>
                <TableCell>{COMPANY.name}</TableCell>
                <TableCell>
                  administrator (art. 6 ust. 1 lit. b RODO - umowa o korzystanie
                  z konta; art. 6 ust. 1 lit. f RODO - bezpieczeństwo i rozwój
                  Serwisu)
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  2. Profil użytkownika: imię, nazwisko, adres zamieszkania,
                  numer PESEL, numer dowodu, data urodzenia, numer telefonu,
                  uprawnienia strzeleckie, podpis.
                </TableCell>
                <TableCell>
                  Każda organizacja, do której użytkownik należy. Jeżeli
                  użytkownik nie należy do żadnej organizacji - {COMPANY.name}.
                </TableCell>
                <TableCell>
                  podmiot przetwarzający w imieniu organizacji; administrator
                  wyłącznie dla kont bez organizacji (art. 6 ust. 1 lit. b RODO)
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  3. Dane organizacyjne: wpisy w książce rejestru pobytu,
                  rezerwacje, członkostwo, składki, deklaracje i zaświadczenia,
                  listy osób z zakazem rezerwacji, treningi na strzelnicy.
                </TableCell>
                <TableCell>
                  Organizacja prowadząca strzelnicę, której wpis dotyczy.
                </TableCell>
                <TableCell>podmiot przetwarzający</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <p>
            Dane warstwy 2 i 3 {COMPANY.name} przetwarza wyłącznie na podstawie
            umowy powierzenia przetwarzania danych osobowych zawartej z
            organizacją, na jej polecenie i w jej celach. Pytania i żądania
            dotyczące tych danych, w tym żądania usunięcia wpisów z książki lub
            danych członkowskich, należy kierować do organizacji prowadzącej
            strzelnicę; {COMPANY.name} przekazuje otrzymane żądania organizacji.
            Żądania dotyczące warstwy 1 oraz profilu konta niezwiązanego z żadną
            organizacją należy kierować do {COMPANY.name} na adres{' '}
            {COMPANY.dataProtectionEmail}.
          </p>
          <p>
            Organizatorzy zawodów korzystający z innych systemów są odrębnymi
            administratorami danych uczestników; jeżeli przekazują dane do
            założenia konta CelPal, dane te trafiają do warstwy 1 i 2 na
            zasadach opisanych wyżej. Dalsza część Polityki opisuje dane, dla
            których administratorem jest {COMPANY.name}.
          </p>

          <Title>Jakie dane zbieramy i w jakim celu?</Title>
          <ol>
            <li>
              Dane konta (warstwa 1): login lub adres e-mail, hasło
              (przechowywane wyłącznie w postaci skrótu kryptograficznego),
              ustawienia dwuskładnikowego uwierzytelniania oraz imię i nazwisko
              podane przy zakładaniu konta - zarówno konta osoby rejestrującej
              organizację, jak i każdego innego konta założonego w Serwisie lub
              aplikacji mobilnej. Dane te są niezbędne do zawarcia i wykonywania
              umowy o korzystanie z konta, w tym do logowania, odzyskiwania
              hasła i powiadomień o zdarzeniach w Serwisie.
            </li>
            <li>
              Profil konta niezwiązanego z organizacją (warstwa 2): dane, które
              użytkownik niebędący członkiem żadnej organizacji zapisuje w swoim
              profilu (adres zamieszkania, dane dokumentów, uprawnienia
              strzeleckie), abyśmy mogli podstawić je do jego przyszłych wpisów
              i rezerwacji. Podanie tych danych jest dobrowolne; z chwilą
              dołączenia do organizacji stają się one danymi powierzonymi tej
              organizacji.
            </li>
            <li>
              Dane organizacji i rozliczeniowe: pełna nazwa, adres siedziby,
              NIP, KRS i REGON organizacji, adres e-mail do korespondencji, dane
              o wybranym pakiecie, historia płatności i faktury. Dane karty
              płatniczej podawane są bezpośrednio operatorowi płatności i nie są
              przechowywane przez Administratora. Dane te są niezbędne do
              zawarcia umowy licencyjnej, pobierania opłat i wystawiania faktur
              VAT, a ich przechowywanie wynika także z przepisów podatkowych i
              rachunkowych.
            </li>
            <li>
              Dane o akceptacji umów: data i godzina akceptacji regulaminu,
              umowy licencyjnej i umowy powierzenia, wersja zaakceptowanego
              dokumentu, dane osoby akceptującej oraz adres IP, z którego
              dokonano akceptacji. Dane te służą udokumentowaniu zawarcia umowy.
            </li>
            <li>
              Dane techniczne i o korzystaniu z Serwisu: adres IP, rodzaj
              urządzenia i przeglądarki, czas połączenia, odwiedzane strony
              Serwisu, zdarzenia w interfejsie oraz komunikaty o błędach. Dane
              te zbieramy automatycznie w celu zapewnienia bezpieczeństwa,
              wykrywania nadużyć, usuwania błędów i rozwijania Serwisu. Do
              analizy korzystania z Serwisu i zgłaszania błędów używamy usługi
              PostHog, której dostawca przetwarza te dane w naszym imieniu na
              serwerach w Unii Europejskiej.
            </li>
            <li>
              Dane kontaktowe: w razie kontaktu z Administratorem (e-mail,
              formularz kontaktowy, reklamacja) przetwarzamy adres e-mail, imię,
              nazwisko, numer telefonu oraz treść korespondencji w celu
              udzielenia odpowiedzi i udokumentowania obsługi zgłoszenia.
            </li>
          </ol>

          <Title>Podstawy prawne przetwarzania</Title>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Cel przetwarzania</TableCell>
                <TableCell>Podstawa prawna</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  zawarcie i wykonywanie umowy o korzystanie z Serwisu, w tym
                  prowadzenie kont użytkowników, obsługa subskrypcji i
                  powiadomienia o zdarzeniach w Serwisie;
                </TableCell>
                <TableCell>
                  art. 6 ust. 1 lit. b) RODO - niezbędność do wykonania umowy
                  lub podjęcia działań przed jej zawarciem.
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  wystawianie i przechowywanie faktur, rozliczenia podatkowe;
                </TableCell>
                <TableCell>
                  art. 6 ust. 1 lit. c) RODO - obowiązek prawny wynikający z
                  przepisów podatkowych i o rachunkowości.
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  udokumentowanie akceptacji regulaminu i umów, ustalenie,
                  dochodzenie i obrona roszczeń;
                </TableCell>
                <TableCell>
                  art. 6 ust. 1 lit. f) RODO - prawnie uzasadniony interes
                  Administratora polegający na możliwości wykazania treści
                  zawartej umowy i obronie przed roszczeniami.
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  zapewnienie bezpieczeństwa Serwisu, wykrywanie nadużyć,
                  usuwanie błędów i rozwijanie Serwisu na podstawie danych o
                  jego używaniu;
                </TableCell>
                <TableCell>
                  art. 6 ust. 1 lit. f) RODO - prawnie uzasadniony interes
                  Administratora polegający na zapewnieniu niezawodnego i
                  bezpiecznego działania Serwisu.
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  odpowiadanie na pytania, reklamacje i inną korespondencję;
                </TableCell>
                <TableCell>
                  art. 6 ust. 1 lit. f) RODO - prawnie uzasadniony interes
                  Administratora polegający na obsłudze zgłoszeń osób
                  kontaktujących się z nim.
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <p>
            Podanie danych jest dobrowolne, lecz niezbędne do założenia konta i
            korzystania z Serwisu.
          </p>
          <p>
            Rejestracja organizacji oraz konta jej administratorów i personelu
            przeznaczone są dla osób pełnoletnich. Konta członków organizacji, w
            tym osób niepełnoletnich, zakładają sami członkowie, dołączając do
            organizacji; ich profil i dane członkowskie (warstwy 2 i 3) są
            przetwarzane w imieniu organizacji jako administratora, która
            odpowiada za podstawę prawną ich przetwarzania, w tym za uzyskanie
            zgody rodzica lub opiekuna prawnego, jeżeli jest wymagana.
          </p>

          <Title>Odbiorcy danych</Title>
          <p>
            Dane osobowe powierzamy podmiotom, które świadczą dla nas usługi
            niezbędne do działania Serwisu, na podstawie umów powierzenia
            przetwarzania i wyłącznie w zakresie niezbędnym do wykonania tych
            usług:
          </p>
          <ul>
            <li>
              Fly.io, Inc. - hosting aplikacji Serwisu (serwery w regionie
              Amsterdam, EOG);
            </li>
            <li>
              ScaleGrid, Inc. - hosting baz danych Serwisu (serwery na terenie
              EOG);
            </li>
            <li>
              Amazon Web Services EMEA SARL - przechowywanie plików przesyłanych
              do Serwisu, w tym dokumentów i zdjęć (region Sztokholm, EOG);
            </li>
            <li>
              Stripe Payments Europe, Ltd. - obsługa płatności za subskrypcję i
              przechowywanie danych kart płatniczych;
            </li>
            <li>
              Comarch S.A. - system fakturowania, za pomocą którego wystawiamy
              faktury VAT i przekazujemy je do Krajowego Systemu e-Faktur;
            </li>
            <li>
              Mailjet SAS (Sinch) - wysyłka wiadomości e-mail z Serwisu
              (aktywacja konta, odzyskiwanie hasła, powiadomienia, faktury);
            </li>
            <li>
              PostHog, Inc. - analityka korzystania z Serwisu i rejestrowanie
              błędów (chmura PostHog w regionie UE, Frankfurt);
            </li>
            <li>
              Cloudflare, Inc. - ochrona Serwisu przed atakami i pośredniczenie
              w ruchu sieciowym.
            </li>
          </ul>
          <p>
            Dane mogą zostać udostępnione także podmiotom upoważnionym na
            podstawie przepisów prawa, w tym organom ścigania i organom
            podatkowym, naszym doradcom prawnym i księgowym oraz
            ubezpieczycielom w razie zgłoszenia roszczenia. W przypadku
            sprzedaży lub reorganizacji przedsiębiorstwa Administratora dane
            mogą wejść w skład przekazywanych aktywów, o czym poinformujemy
            osoby, których dane dotyczą.
          </p>

          <Title>Gdzie są przetwarzane dane?</Title>
          <p>
            Dane osobowe przetwarzane są co do zasady na terenie Europejskiego
            Obszaru Gospodarczego. Niektórzy z wymienionych wyżej dostawców mają
            siedzibę w Stanach Zjednoczonych lub mogą korzystać z infrastruktury
            poza EOG; w takim przypadku przekazanie danych odbywa się na
            podstawie decyzji Komisji Europejskiej stwierdzającej odpowiedni
            stopień ochrony (Data Privacy Framework) lub standardowych klauzul
            umownych przyjętych przez Komisję Europejską.
          </p>

          <Title>Jak długo przechowujemy dane?</Title>
          <p>
            Dane konta i organizacji przechowujemy przez czas trwania umowy o
            korzystanie z Serwisu. Po jej zakończeniu pozostają one w Serwisie,
            aby organizacja mogła wznowić korzystanie z niego, do czasu
            zgłoszenia przez organizację żądania ich usunięcia na adres{' '}
            {COMPANY.dataProtectionEmail}; usuwamy je lub anonimizujemy w
            terminie 30 dni od otrzymania żądania. Przed zgłoszeniem żądania
            organizacja może pobrać wpisy z książki rejestru pobytu oraz listę
            kont za pomocą funkcji eksportu dostępnych w Oprogramowaniu. Dane
            rozliczeniowe i faktury przechowujemy przez okres wymagany
            przepisami podatkowymi i rachunkowymi (co do zasady 5 lat od końca
            roku, w którym powstał obowiązek podatkowy). Dane o akceptacji umów
            przechowujemy do upływu okresu przedawnienia roszczeń z umowy. Dane
            techniczne i logi przechowujemy nie dłużej niż 12 miesięcy, chyba że
            są potrzebne do wyjaśnienia incydentu bezpieczeństwa.
          </p>

          <Title>Pliki cookies i pamięć przeglądarki</Title>
          <p>
            Serwis używa plików cookies niezbędnych do jego działania: do
            utrzymania sesji zalogowanego użytkownika, zapamiętania wybranego
            języka i trybu kolorów oraz do ochrony przed atakami. Na ich użycie
            nie jest wymagana zgoda. Narzędzie analityczne PostHog zapisuje
            identyfikator w pamięci lokalnej przeglądarki (localStorage), a nie
            w plikach cookies; dane te służą Administratorowi do analizy
            działania Serwisu i są przetwarzane przez dostawcę PostHog wyłącznie
            w naszym imieniu. Serwis nie używa cookies reklamowych.
          </p>

          <Title>Jakie są zobowiązania Administratora?</Title>
          <p>
            Administrator stosuje środki techniczne i organizacyjne zapewniające
            bezpieczeństwo przetwarzanych danych osobowych, w szczególności
            szyfrowanie połączeń z Serwisem, szyfrowanie wrażliwych danych w
            bazie danych, przechowywanie haseł w postaci skrótu
            kryptograficznego, kontrolę dostępu oparta na rolach, dwuskładnikowe
            uwierzytelnianie administratorów organizacji oraz regularne kopie
            zapasowe. Dostęp do danych mają wyłącznie osoby upoważnione i
            zobowiązane do zachowania poufności.
            <br />
            <br />
            Administrator informuje, że przetwarza, zgodnie z przepisami prawa,
            dane dotyczące urządzenia końcowego użytkownika (w tym adres IP)
            oraz czasu połączenia z Serwisem. Dane te przetwarzane są w celach
            technicznych, bezpieczeństwa oraz w celu zbierania ogólnych danych
            statystycznych.
          </p>

          <Title>Jakie są uprawnienia osób, których dane dotyczą?</Title>
          <p>
            Każdej osobie przysługuje prawo dostępu do swoich danych, ich
            sprostowania, usunięcia lub ograniczenia przetwarzania, prawo do
            przenoszenia danych oraz prawo sprzeciwu wobec przetwarzania
            opartego na prawnie uzasadnionym interesie Administratora. Żądania
            należy kierować na adres{' '}
            <a href={`mailto:${COMPANY.dataProtectionEmail}`}>
              {COMPANY.dataProtectionEmail}
            </a>
            . Dane konta i organizacji można także samodzielnie poprawiać w
            ustawieniach Serwisu. Usunięcie danych niezbędnych do wykonywania
            umowy uniemożliwi dalsze korzystanie z Serwisu.
            <br />
            <br />
            Każdej osobie przysługuje prawo wniesienia skargi do Prezesa Urzędu
            Ochrony Danych Osobowych (ul. Stawki 2, 00-193 Warszawa), gdy uzna,
            że przetwarzanie jej danych osobowych narusza przepisy prawa.
          </p>

          <Title>Zmiany Polityki</Title>
          <p>
            Administrator może zmienić Politykę, w szczególności w razie zmiany
            zakresu usług Serwisu, zmiany dostawców lub zmiany przepisów prawa.
            O zmianach informujemy w Serwisie oraz e-mailem na adres podany przy
            rejestracji, nie później niż 14 dni przed ich wejściem w życie,
            publikując jednocześnie nową treść Polityki pod adresem
            https://celpal.net/polityka-prywatnosci.
          </p>
        </Content>
      </Box>
    </PageSkeleton>
  )
}

const Title = styled.div`
  font-weight: bold;
  margin: 16px 0;
`

const Content = styled.div`
  text-align: justify;
  max-width: 700px;
  margin: 0 32px;
`
